import { render, staticRenderFns } from "./LoanOfficerContactCard.vue?vue&type=template&id=4e8d50cb&scoped=true&"
import script from "./LoanOfficerContactCard.vue?vue&type=script&lang=ts&"
export * from "./LoanOfficerContactCard.vue?vue&type=script&lang=ts&"
import style0 from "./LoanOfficerContactCard.vue?vue&type=style&index=0&id=4e8d50cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8d50cb",
  null
  
)

export default component.exports